import React from 'react';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { BookingDetailTitle, BookingGuarantor } from '@components';
import { FieldV2 } from 'components/common/form-controls';
import { INSTACAR_BANK_ACCOUNTS, INSTACAR_PAYMENT_METHODS } from '@constants';
import BillingDetails from './BillingDetails';

import styles from './bookingPaymentBilling.style';

const BookingPaymentBilling = ({
  user,
  subscription,
  billingInfos = [],
  hideAddButton = false,
  onUpdateGuarantor,
  onDeleteGuarantor,
  onGetUser,
  onGetData,
  onSubmit,
}) => {
  const methods = useFormContext();

  return (
    <Box sx={styles.section}>
      <Box sx={styles.titleRow}>
        <BookingDetailTitle>Initial Payment Details</BookingDetailTitle>
      </Box>
      <Box sx={styles.row}>
        <FieldV2
          label="Payment Method"
          type="dropdown"
          control={methods.control}
          options={INSTACAR_PAYMENT_METHODS}
          name="initialPaymentDetails.paymentMethod"
        />
        <FieldV2
          label="Bank of Payment"
          type="dropdown"
          options={INSTACAR_BANK_ACCOUNTS}
          control={methods.control}
          name="initialPaymentDetails.bankName"
        />
        <FieldV2
          label="Customer's IBAN"
          control={methods.control}
          name="initialPaymentDetails.iban"
        />
      </Box>
      <Box sx={styles.row}>
        <FieldV2
          label="Date of Initial Payment"
          type="date"
          control={methods.control}
          name="initialPaymentDetails.paymentDate"
        />
        <FieldV2
          label="Paid Amount"
          type="number"
          control={methods.control}
          name="initialPaymentDetails.paymentAmount"
        />
      </Box>

      <Box sx={styles.titleRow}>
        <BookingDetailTitle>Recurring Payment Infos</BookingDetailTitle>
      </Box>
      <Box sx={styles.row}>
        <FieldV2
          label="Payment Method"
          type="dropdown"
          control={methods.control}
          options={INSTACAR_PAYMENT_METHODS}
          name="recurringPaymentDetails.paymentMethod"
        />
        <FieldV2
          label="Bank of Payment"
          type="dropdown"
          options={INSTACAR_BANK_ACCOUNTS}
          control={methods.control}
          name="recurringPaymentDetails.bankName"
        />
        <FieldV2
          label="Customer's IBAN"
          control={methods.control}
          name="recurringPaymentDetails.iban"
        />
      </Box>
      <Box sx={styles.row}>
        <FieldV2
          label="Payment Due Date"
          control={methods.control}
          name="recurringPaymentDetails.paymentDueDate"
        />
        <FieldV2
          label="Paid Amount"
          type="number"
          control={methods.control}
          name="recurringPaymentDetails.paymentAmount"
        />
      </Box>
      <BillingDetails
        billingInfos={user?.billingInfo || billingInfos}
        onGetUser={onGetUser}
        onGetData={onGetData}
        user={user}
        subscription={subscription}
        hideAddButton={hideAddButton}
        onSubmit={onSubmit}
      />
      <BookingGuarantor
        methods={methods}
        onUpdateGuarantor={onUpdateGuarantor}
        onDeleteGuarantor={onDeleteGuarantor}
      />
    </Box>
  );
};

export default BookingPaymentBilling;
